import { render } from "./MButton.vue?vue&type=template&id=7abba2eb"
import script from "./MButton.vue?vue&type=script&lang=js"
export * from "./MButton.vue?vue&type=script&lang=js"

import "./MButton.vue?vue&type=style&index=0&id=7abba2eb&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__